export default {"src":"/_next/static/media/rigthButtonNot.ecbc7495.svg","height":9,"width":9};